import axiosConfig from '../axiosConfig';
import store from "../storeConfig";

import axios from "axios";
import getEnvVars from "../../enviroment";
import { Auth } from "aws-amplify";
import { out } from 'react-native/Libraries/Animated/Easing';
import { Platform } from 'react-native';

const baseURL = getEnvVars().apiUrl;

export async function loadUserInvestDetails() {
    const alreadyLoaded = store.getState().invest.userCacheDataLoaded;
    if (alreadyLoaded) {
        // bail on resetting if we've run this once?
        return true;
    }
    // const user = await Auth.currentAuthenticatedUser();
    // const datastr = user.attributes["custom:cacheDetails"];
    // if (datastr == '' || datastr == undefined) {
    //     setUserInvestID(0);
    //     return false;
    // }
    // let userID = datastr.slice(0, -1);
    // let encDat = datastr.slice(-1);
    // setUserInvestID(userID);

    checkCacheData();

    // let KYCVeri = false;
    // let Banking = false;
    // let Invested = false;

    // // todo write shortcut if val = 7
    // let binStr = parseInt(encDat, 16).toString(2).padStart(3, '0');
    // let binArr = binStr.split('');
    // store.dispatch({
    //     type: 'LOAD_USER_BULK_DETAILS',
    //     KYCVeri: Boolean(parseInt(binArr[0])),
    //     Banking: Boolean(parseInt(binArr[1])),
    //     InvestMode: Boolean(parseInt(binArr[2]))
    // })
}

export function getStatementList() {
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        axi.get('invest/listStatements').then(async (result) => {
            store.dispatch({
                type: 'LOAD_STATEMENT_LIST',
                statementList: result.data
            })
        });
    });
}

export function getStatementByFilename(filename) {
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                "Accept": "application/pdf",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            },
            responseType: "blob"
        });

        let statementData = store.getState().invest.statementList.slice();
        let matchingStatementIndex = statementData.findIndex((element) => element.path === filename);

        if(statementData[matchingStatementIndex].blobLoaded == true) {
            return;
            // stop multi-hit
        } else {
            let formBody = `{
                "report_path": "${filename}"
            }`;

            axi.post('invest/getStatement', formBody).then(async (result) => {
                // console.log(result.data);
                let dataBlob = new Blob([result.data], { type: 'application/pdf' });
                
                statementData[matchingStatementIndex].blob = dataBlob;
                statementData[matchingStatementIndex].blobLoaded = true;
                
                store.dispatch({
                    type: 'LOAD_STATEMENT_LIST',
                    statementList: statementData
                })

                // if (Platform.OS == 'web') {
                //     let URI = URL.createObjectURL(dataBlob);
                //     window.open(URI, "_blank");
                // } else {
                //     //native
                //     const fr = new FileReader();
                //     fr.onload = async () => {
                //         const fileURI = `${FileSystem.documentDirectory}/Statement.pdf`;
                //         await FileSystem.writeAsStringAsync(fileURI, fr.result.split(',')[1], { encoding: 'base64'});
                //         Sharing.shareAsync(fileUri);
                //     }
                //     // await console.log(data);
                //     fr.readAsDataURL(dataBlob);
                // }
            });
        }
    });
}

export function setUserInvestID(id) {
    store.dispatch({
        type: 'LOAD_USER_INVEST_ID',
        userInvestmentID: id
    })
}

export async function submitUserSignupForm(formBody, errorHandlingFunc, navigation) {
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        axi.post('invest/signup', formBody).then(async (result) => {
            if (Number.isInteger(result.data.investor_id)) {
                const u = await Auth.currentAuthenticatedUser();
                const r = await Auth.updateUserAttributes(u, {
                    "custom:cacheDetails": `${result.data.investor_id}0`,
                });
                store.dispatch({
                    type: 'LOAD_USER_INVEST_ID',
                    userInvestmentID: result.data.investor_id
                })
                checkKYCVerification();
                navigation.navigate("InvestHome");
                return true;
            } else {
                errorHandlingFunc(JSON.stringify(result.data));
                return result.data;
            }
        });
    });
}

export function submitUserInitialBankingDetails(formBody, navigation) {
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        axi.post('invest/bankingDetails', formBody).then(async (result) => {
            if (!Number.isInteger(result.data.status)) {
                checkBankingDetails();
                navigation.navigate("InvestHome")
                return true;
            } else {
                return result.data;
            }
        });
    });
}

export function submitUserInitialInvestmentType(formBody, errorHandlingFunc, navigation) {
    // used for "ADD" type submissions
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        axi.post('invest/investmentPreference', formBody).then(async (result) => {
            // console.log(result.data);
            if (!Number.isInteger(result.data.status)) {
                navigation.navigate("AddInvestmentNotificationConfirm");
                return true;
            } else {
                errorHandlingFunc(result.data.data);
                return false;
            }
        });
    });
}

export function submitSwitchInstruction(formBody, errorHandlingFunc, navigation) {
    // used for "SWITCH" type submissions
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        axi.post('invest/switchInvestment', formBody).then(async (result) => {
            if (!Number.isInteger(result.data.status)) {
                navigation.navigate("SwitchInvestmentNotificationConfirm");
                return true;
            } else {
                errorHandlingFunc(result.data.data);
                return false;
            }
        });
    });
}

export function submitWithdrawInstruction(formBody, errorHandlingFunc, navigation) {
    // used for "WITHDRAW" type submissions
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        axi.post('invest/withdrawRequest', formBody).then(async (result) => {
            if (!Number.isInteger(result.data.status)) {
                navigation.navigate("SwitchInvestmentNotificationConfirm");
                return true;
            } else {
                errorHandlingFunc(result.data.data);
                return false;
            }
        });
    });
}

export async function updateParityBit() {
    let userinvestID = store.getState().invest.userInvestmentID;
    let KYC = Number(store.getState().invest.userKYCVerified);
    let banking = Number(store.getState().invest.userBankingDetails);
    let setInitialInvestment = Number(store.getState().invest.userInvestMode);

    let boolStr = KYC.toString().concat(banking.toString()).concat(setInitialInvestment.toString());
    let encStr = parseInt(boolStr, 2).toString(16);

    const u = await Auth.currentAuthenticatedUser();
    const r = await Auth.updateUserAttributes(u, {
        "custom:cacheDetails": `${userinvestID.concat(encStr)}`,
    });
}

async function setCachePhoneNumber(phoneNumberAU) {

    if(phoneNumberAU.charAt(0) === '0') {
        phoneNumberAU = '+61'.concat(phoneNumberAU.substring(1));
    }

    const u = await Auth.currentAuthenticatedUser();
    const r = await Auth.updateUserAttributes(u, {
        "custom:cachePhoneNumber": `${phoneNumberAU}`,
    });
}

export function checkBankingDetails() {
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        axi.get('invest/bankingDetails').then(async (result) => {
            if (result.data.provided === true) {
                store.dispatch({
                    type: 'LOAD_USER_BANKING_DETAILS',
                    cacheBankingData: result.data.bank_account_number_secured
                })
                updateParityBit();
                return true;
            } else {
                // todo move to bad time screen
                return false;
            }
        });
    });
}

export function checkCacheData(freshKYC = false) {
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        axi.get('invest/details').then(async (result) => {
            if (Number.isInteger(result.data.investor_id)) {
                store.dispatch({
                    type: 'LOAD_USER_CACHE_DETAILS',
                    cacheUserData: result.data
                })
                var hasntCachePho = store.getState().user.user.attributes['custom:cachePhoneNumber'] == undefined || store.getState().user.user.attributes['custom:cachePhoneNumber'] == '' ? true : false;
                if(freshKYC || hasntCachePho) {
                    setCachePhoneNumber(result.data.mobile_number);
                }
                checkPendingTransactions();
                // updateParityBit();
                return true;
            } else {
                // todo move to bad time screen
                return false;
            }
        });
    });
}

export function checkKYCVerification() {
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        axi.get('invest/signup').then(async (result) => {
            if (result.data.status === "VERIFIED") {
                store.dispatch({
                    type: 'SET_USER_KYC_VERI'
                })
                updateParityBit();
                checkCacheData(true);
                return true;
            } else if (result.data.status === "VERIFICATION_FAILED") {
                // todo move to bad time screen
                return false;
            } else {
                return true;
            }
        });
    });
}

export function checkPendingTransactions() {
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        axi.get('invest/checkTransactions').then(async (result) => {
            if (result.data === []) {
                return;
            } else  {
                let isPending = result.data.every(el => {
                    if (el.transaction_status === "Unitised") return true;
                    if (el.transaction_status === "Rejected") return true;
                    return false;
                });
    
                if (!isPending) {
                    let pendingAmount = result.data.filter(el => el.transaction_status !== "Unitised" && el.transaction_status !== "Rejected")

                               .reduce((acc, el) => {
                                if (el.transaction_type === "SWITCH") {
                                    return acc + Number.parseFloat(Math.abs(el.options[0].amount));
                                 }
                                return acc + Number.parseFloat(el.options[0].amount);
                               },0);

                    store.dispatch({
                        type: 'SET_HAS_PENDING_TRANSACTION',
                        pendingTransaction: true,
                        pendingAmount: pendingAmount
                    })
                }
            }
        });
    });
    // "transaction_status": "Unitised" - only "valid" transaction type?
}

export function confirmedKYCSet() {
    store.dispatch({
        type: 'SET_USER_KYC_VERI'
    })
    updateParityBit();
}

export function setCurrentInvestmentType(investmentTypeID) {
    store.dispatch({
        type: 'SET_INVEST_DETAIL_ID',
        investTypeId: investmentTypeID
    })
}

function parseHistoricalData(dataArray) {
    let outputArray = [
        {
            label: "Australian Shares",
            id: 7,
            amount: 0.00,
            unitprice: 0,
            chartData: {
                label: [],
                data: []
            }
        },
        {
            label: "Cash",
            shortLabel: "Cash",
            id: 1,
            amount: 0,
            unitprice: 0,
            chartData: {
                label: [],
                data: []
            }
        },
        {
            label: "FANG Plus Shares",
            shortLabel: "FANG Plus Shares",
            id: 2,
            amount: 0.00,
            unitprice: 0,
            chartData: {
                label: [],
                data: []
            }
        },
        {
            label: "Gold",
            shortLabel: "Gold",
            id: 3,
            amount: 0,
            unitprice: 0,
            chartData: {
                label: [],
                data: []
            }
        },
        {
            label: "International Sustainability",
            shortLabel: "Int. Sustainability",
            id: 4,
            amount: 0.00,
            unitprice: 0,
            chartData: {
                label: [],
                data: []
            }
        },
        {
            label: "NASDAQ Shares",
            shortLabel: "NASDAQ Shares",
            id: 5,
            amount: 0,
            unitprice: 0,
            chartData: {
                label: [],
                data: []
            }
        },
        {
            label: "US Shares",
            shortLabel: "US Shares",
            id: 6,
            amount: 0.00,
            unitprice: 0,
            chartData: {
                label: [],
                data: []
            }
        }
    ];;
    // Step 1: read all historical data objects, put $ data in output array
    dataArray.forEach(el => {
        if (el.investment_option != undefined) {
            let investmentOptionObject = outputArray.find((finding) => finding.id === el.investment_option.investment_option_id);
            if (investmentOptionObject === undefined) {
                outputArray.push({
                    id: el.investment_option.investment_option_id,
                    chartData: {
                        label: [],
                        data: []
                    }
                });
                investmentOptionObject = outputArray.find((finding) => finding.id === el.investment_option.investment_option_id);
            }
            investmentOptionObject.chartData.label.push(el.holding_date);
            investmentOptionObject.chartData.data.push(el.holding_value);
        }
    });
    // Step 2: add additional data to output array as appropriate
    const idToLabelEnum = [
        {label: "Australian Shares", shortLabel: "Australian Shares",id: 7, sortingOrder: 1},
        {label: "Cash", shortLabel: "Cash", id: 1, sortingOrder: 2},
        {label: "FANG Plus Shares", shortLabel: "FANG Plus Shares", id: 2, sortingOrder: 3},
        {label: "Gold", shortLabel: "Gold", id: 3, sortingOrder: 4},
        {label: "International Sustainability", shortLabel: "Int. Sustainability", id: 4, sortingOrder: 5},
        {label: "NASDAQ Shares", shortLabel: "NASDAQ Shares", id: 5, sortingOrder: 6},
        {label: "US Shares", shortLabel: "US Shares", id: 6, sortingOrder: 7}
    ]

    outputArray.forEach(el => {
        //label
        el.label = idToLabelEnum.find(elm => elm.id === el.id).label;
        el.shortLabel = idToLabelEnum.find(elm => elm.id === el.id).shortLabel;
        //amount
        el.amount = el.chartData.data.slice(-1)[0];
        if (el.amount === undefined) { el.amount = 0.00 }
    });

    // Step 2.5 - sort;
    outputArray.sort((a,b) => idToLabelEnum.find(elm => elm.id === a.id).sortingOrder - idToLabelEnum.find(elm => elm.id === b.id).sortingOrder);

    return outputArray;
    // Step 3: grab additional information for these from accurate balance API
}

function getAccurateBalanceData(historicalArr) {
    const curTimeScale = store.getState().invest.historicalLoadedDays;
    // takes array and adds balance data
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        axi.get('invest/balance').then(async (result) => {
            if (result.data === []) {
                return true;
            } else  {
                result.data.forEach((item) => {
                    historicalArr.find(elm => elm.id === item.investment_option.investment_option_id).amount = item.cleared_value;
                    historicalArr.find(elm => elm.id === item.investment_option.investment_option_id).unitprice = item.latest_price;
                })
                store.dispatch({
                    type: 'SET_LOADED_TRANSACTION_DATA',
                    timeScale: curTimeScale,
                    transactionData: historicalArr
                });
                return true;
            }
        });
    });
}

export function updateTimescale(newTimeScale) {
    const curTimeScale = store.getState().invest.historicalLoadedDays;
    // console.log(`timescale ${curTimeScale} ; new ${newTimeScale}`);
    if (newTimeScale <= curTimeScale)
        return; // already have data
    else {
        store.dispatch({type: 'SET_LOADING_HISTORICAL_DATA_FLAG'});
        loadInvestTransactions(newTimeScale);
    }
}

export function loadInvestTransactions(timescale = 30) {
    const curTimeScale = store.getState().invest.historicalLoadedDays;
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        axi.get('invest/balance/historical?timeScale='.concat(timescale)).then(async (result) => {
            if (result.data.length == 0) {
                // no historical data - use blank data slate
                const loadedData = [
                    {
                        label: "Australian Shares",
                        shortLabel: "Australian Shares",
                        id: 7,
                        amount: 0.00,
                        unitprice: 0,
                        chartData: {
                            label: [],
                            data: []
                        }
                    },
                    {
                        label: "Cash",
                        shortLabel: "Cash",
                        id: 1,
                        amount: 0,
                        unitprice: 0,
                        chartData: {
                            label: [],
                            data: []
                        }
                    },
                    {
                        label: "FANG Plus Shares",
                        shortLabel: "FANG Plus Shares",
                        id: 2,
                        amount: 0.00,
                        unitprice: 0,
                        chartData: {
                            label: [],
                            data: []
                        }
                    },
                    {
                        label: "Gold",
                        shortLabel: "Gold",
                        id: 3,
                        amount: 0,
                        unitprice: 0,
                        chartData: {
                            label: [],
                            data: []
                        }
                    },
                    {
                        label: "International Sustainability",
                        shortLabel: "Int. Sustainability",
                        id: 4,
                        amount: 0.00,
                        unitprice: 0,
                        chartData: {
                            label: [],
                            data: []
                        }
                    },
                    {
                        label: "NASDAQ Shares",
                        shortLabel: "NASDAQ Shares",
                        id: 5,
                        amount: 0,
                        unitprice: 0,
                        chartData: {
                            label: [],
                            data: []
                        }
                    },
                    {
                        label: "US Shares",
                        shortLabel: "US Shares",
                        id: 6,
                        amount: 0.00,
                        unitprice: 0,
                        chartData: {
                            label: [],
                            data: []
                        }
                    }
                ];
                store.dispatch({
                    type: 'SET_LOADED_TRANSACTION_DATA',
                    timeScale: curTimeScale,
                    transactionData: loadedData
                });
                return true;
            } else {
                let historicalData = parseHistoricalData(result.data);
                store.dispatch({
                    type: 'SET_LOADED_TRANSACTION_DATA',
                    timeScale: timescale,
                    transactionData: historicalData
                });
                getAccurateBalanceData(historicalData);
                return true;
            }
        });
    });
    
}

export function loadRecurringTransactions() {
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        axi.get('invest/recurring').then(async (result) => {
            // console.log(result);
            if(result.data[0] != undefined)
                store.dispatch({
                    type: 'LOAD_RECURRING_TRANSACTIONS',
                    recurringInstructions: result.data[0].recurringInstruction
                });
            else {
                store.dispatch({
                    type: 'LOAD_RECURRING_TRANSACTIONS',
                    recurringInstructions: []
                });
            }
        });
    });
}

export async function cancelRecurringTransaction(transactionId) {
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        axi.post('invest/recurring?instruction='.concat(transactionId)).then(async (result) => {
            // console.log(result);
            return true;
        });
    });
}